import { _addStoreHandlers, } from '../service/store';
import { _s2latLngs, _latLngs2s, } from '../route-service/route-encoding';
import { _$map, } from '../route-service/map';
import { _routes, } from '../route-service/route-registry';
import { _addMultipleRoutes, } from './edit-route';
const _loadRoutes = (routeEncoding) => {
    const latLngSeqs = _s2latLngs(routeEncoding);
    _addMultipleRoutes(latLngSeqs, _$map);
}, _saveRoutes = () => {
    const routes = _routes(), latLngSeqs = _allRouteLatLngs(routes);
    for (const route of routes) {
        route.len().set();
    }
    return _latLngs2s(latLngSeqs);
}, _allRouteLatLngs = (routes) => {
    const latLngSeqs = [];
    for (const routeId in routes) {
        const route = routes[routeId], latLngs = _routeLatLngs(route);
        latLngSeqs.push(latLngs);
    }
    return latLngSeqs;
}, _routeLatLngs = (route) => {
    const latLngs = [];
    let currentPoint = route.s();
    while (currentPoint) {
        const currentLatLng = currentPoint.m().getLatLng();
        latLngs.push(currentLatLng);
        currentPoint = currentPoint.np();
    }
    return latLngs;
};
_addStoreHandlers('r', _loadRoutes, _saveRoutes);
